<template>
  <Transition name="slide-down">
    <div
      v-if="isOffline"
      data-testid="offline-indicator"
      class="fixed top-0 left-0 right-0 z-50 bg-orange-500 text-white px-4 py-3 shadow-lg"
    >
      <div class="container mx-auto flex items-center justify-center gap-2">
        <LucideWifiOff :size="20" />
        <span class="text-sm font-semibold">
          Sin conexión - Mostrando contenido guardado
        </span>
      </div>
    </div>
  </Transition>
</template>

<script lang="ts" setup>
import { useOnlineStatus } from '~~/composables/useOnlineStatus';
const { isOffline } = useOnlineStatus();
</script>

<style scoped>
.slide-down-enter-active,
.slide-down-leave-active {
  transition:
    transform 0.3s ease,
    opacity 0.3s ease;
}

.slide-down-enter-from,
.slide-down-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}

.slide-down-enter-to,
.slide-down-leave-from {
  transform: translateY(0);
  opacity: 1;
}
</style>
